export default {
  timeText: {
    color: data => data.color,
  },
};



// WEBPACK FOOTER //
// ./default-modules/ui/controls/time/time.theme.ts